<mat-sidenav-container class="flex-column shell" [class.shell--compact]="isCompact()">
  <mat-sidenav class="flex-column sidebar" [mode]="isCompact() ? 'over' : 'side'"
    [opened]="!isCompact() || drawerOpen()" [fixedInViewport]="isCompact()" (closedStart)="closeDrawer()">
    <div class="top-sidenav">
      <div class="gap-flex-12 brand-container">
        <app-svg-icon class="toolbox-icon" path="/assets/icons/toolBox.svg" />
        <div class="flex-column brand-texts-container">
          <span class="brand-text">Toolbox</span>
          <span class="brand-subtext">Diagnostics</span>
        </div>
        <button *ngIf="isCompact()" type="button" class="drawer-close" aria-label="Close menu" (click)="closeDrawer()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <nav *ngIf="authservice.rolesLoaded()" class="flex-column nav">
        <ng-container *ngIf="isAdmin || isViewOnly">
          <a routerLink="/app" routerLinkActive="active" class="text-muted-md nav-link" (click)="closeDrawer()">
            <app-svg-icon class="sidebar-icon" path="/assets/icons/dashboard.svg" />
            <span>Dashboard</span>
          </a>
          <a routerLink="/message-queue" routerLinkActive="active" class="text-muted-md nav-link" (click)="closeDrawer()">
            <app-svg-icon class="sidebar-icon" path="/assets/icons/diagnostics.svg" />
            <span>Message Queue</span>
          </a>
          <a routerLink="/customers" routerLinkActive="active" class="text-muted-md nav-link" (click)="closeDrawer()">
            <app-svg-icon class="sidebar-icon" path="/assets/icons/person.svg" />
            <span>Customers</span>
          </a>
          <a routerLink="/alerts" routerLinkActive="active" class="text-muted-md nav-link" (click)="closeDrawer()">
            <app-svg-icon class="sidebar-icon" path="/assets/icons/bell.svg" />
            <span>Alerts</span>
            <span class="nav-badge text-white-xs" *ngIf="(unresolvedVenueCount$ | async) as count">{{
              count }}</span>
          </a>
          <a routerLink="/snapshots" routerLinkActive="active" class="text-muted-md nav-link" (click)="closeDrawer()">
            <app-svg-icon class="sidebar-icon" path="/assets/icons/camera.svg" />
            <span>Snapshots</span>
          </a>
          <!-- <a routerLink="/integrations" routerLinkActive="active" class="text-muted-md nav-link">
            <app-svg-icon class="sidebar-icon" path="/assets/icons/integrations.svg" />
            <span>Integrations</span>
          </a> -->
          <a *ngIf="isAdmin" routerLink="/settings" routerLinkActive="active" class="text-muted-md nav-link"
            (click)="closeDrawer()">
            <app-svg-icon class="sidebar-icon" path="/assets/icons/settings.svg" />
            <span>Settings</span>
          </a>
        </ng-container>
        <a routerLink="/support" routerLinkActive="active" class="text-muted-md nav-link" (click)="closeDrawer()">
          <app-svg-icon class="sidebar-icon" path="/assets/icons/support.svg" />
          <span>Support</span>
        </a>
      </nav>
    </div>
    <ng-container *ngIf="{ backend: backendVersion$ | async } as v">
      <div class="flex-column gap-flex-8 version-container">
        <div class="version-row">
          <span class="version-label">App</span>
          <span class="version-badge">v{{ version }}</span>
        </div>
        <div class="version-row">
          <span class="version-label">
            <span class="status-dot" [class.online]="v.backend" [class.offline]="!v.backend"></span>
            API
          </span>
          <span class="version-badge" *ngIf="v.backend; else apiUnavailable">v{{ v.backend }}</span>
          <ng-template #apiUnavailable>
            <span class="version-badge version-badge--muted">unavailable</span>
          </ng-template>
        </div>
      </div>
    </ng-container>
  </mat-sidenav>

  <mat-sidenav-content class="shell-content">
    <mat-toolbar class="gap-flex-16 top-toolbar">
      <button *ngIf="isCompact()" type="button" class="menu-button" aria-label="Open menu" (click)="toggleDrawer()">
        <mat-icon>menu</mat-icon>
      </button>
      <div *ngIf="isCompact()" class="gap-flex-8 compact-brand">
        <app-svg-icon class="toolbox-icon" path="/assets/icons/toolBox.svg" />
        <span class="brand-text">Toolbox</span>
      </div>
      <span *ngIf="!isCompact()" class="search-container">
        <app-search-field class="search-field" (search)="onSearch($event)" (selectedData)="openDetails($event)"
          [placeholder]="'Search venues by name, ID, address, or group...'" [isCustomerDropdown]="true"
          [filteredItems]="(customersFacadeService.filteredCustomers$ | async) ?? []"></app-search-field>
      </span>
      <span *ngIf="isCompact()" class="toolbar-spacer"></span>
      <span *ngIf="!isCompact()" class="text-muted-sm">Last updated: {{ lastUpdated }}</span>
      <button class="refresh-button text-sm" (click)="refreshData()" [attr.aria-label]="'Refresh data'"
        [matTooltip]="isCompact() ? 'Refresh data. Last updated ' + lastUpdated : ''">
        <mat-icon>refresh</mat-icon>
        <span *ngIf="!isCompact()">Refresh Data</span>
      </button>
      <button *ngIf="authservice.user() as user" [matMenuTriggerFor]="userMenu"
        class="flex-row gap-flex-4 user-menu" [attr.aria-label]="'Account menu for ' + user.name"
        [matTooltip]="user.name">
        <div class="avatar">{{ user.initials }}</div>
        <mat-icon *ngIf="!isCompact()" class="text-muted-md">expand_more</mat-icon>
      </button>
    </mat-toolbar>
    <div *ngIf="isCompact()" class="compact-search">
      <app-search-field class="search-field" (search)="onSearch($event)" (selectedData)="openDetails($event)"
        [placeholder]="'Search venues...'" [isCustomerDropdown]="true"
        [filteredItems]="(customersFacadeService.filteredCustomers$ | async) ?? []"></app-search-field>
    </div>

    <main class="content">
      <router-outlet></router-outlet>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>

<mat-menu #userMenu="matMenu" class="user-menu-panel">
  <div class="user-menu-identity flex-row gap-flex-12" *ngIf="authservice.user() as user"
    (click)="$event.stopPropagation()">
    <div class="avatar">{{ user.initials }}</div>
    <div class="flex-column-start user-menu-identity-text">
      <span class="brand-text-sm">{{ user.name }}</span>
      <small class="text-muted-xs">{{ user.email }}</small>
      <span class="user-menu-role text-muted-xs" *ngIf="roleLabel() as label">{{ label }}</span>
    </div>
  </div>
  <div class="user-menu-divider"></div>
  <button mat-menu-item (click)="logout()">
    <mat-icon class="logout-icon">exit_to_app</mat-icon>
    Logout
  </button>
</mat-menu>
